var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('Front-Header'),_c('div',{staticClass:"basemap",staticStyle:{"width":"600px","height":"600px"},attrs:{"id":"map"}}),_c('Front-Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }